<script>
    /**
     * Prompt
     */
    import ModalHeader from './ModalHeader.vue';
    import ModalFooter from './ModalFooter.vue';
    import NormalButton from '../widgets/NormalButton.vue';
    import DropDown from '../widgets/DropDown.vue';
    import MultipleSelect from '../widgets/MultipleSelect.vue';
    import NormalInput from '../widgets/NormalInput.vue';
    import NormalRadio from '../widgets/NormalRadio.vue';
    import CheckBox from '../widgets/CheckBox.vue';
    import CheckBoxGroup from '../widgets/CheckBoxGroup.vue';
    import NormalFileButton from '../widgets/NormalFileButton';
    import NormalLabel from '../widgets/NormalLabel';

    export default {
        alias: 'prompt',
        defaultOptions () {
            return {
                title: '提示',
                okDisabledCheck: null,
                cancelDisabledCheck: null
            };
        },
        modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
            if (!this.value) {
                this.value = '';
            }
            if (this.type === 'multipleSelect') {
                this.value = this.data.selected;
            }
        },
        data () {
            return {
                isReverse: true,
                title: '',
                text: '',
                value: '',
                contentClass: '',
                type: 'text',
                catCharSelectMap: new Map(),
                placeholder: '',
                placeholderText: '',
                maxlength: '',
                //                tips: '',
                data: {selected: ''},
                limit: 0,
                check: function () {
                    return true;
                },
                errormessage: '',
                btnText: ['确定', '取消'],
                isDrag: true,
                sampleText: '',
                limitShow: 2,
                multiSelShowCheckedAll: false,
                multiWithSearch: false,
                showMultiChoosed: false,
                showCancelOpera: true,
                okDisabledCheck: function () {
                    return false
                },
                cancelDisabledCheck: function () {
                    return false
                },
                resize: {}
            };
        },
        name: 'modal-prompt',
        methods: {
            onPrompt () {
                this.errormessage = this.check && this.check(this.value, this.data);
                if (this.errormessage === true || this.errormessage === undefined) {
                    this.okCallback && this.okCallback(this.value, this.data);
                    this.close();
                }
                // else if (typeof this.errormessage === 'string') {
                //     this.$alias.error(this.errormessage);
                // }
            },
            onDestroy () {
                if (this.cancelCallback) {
                    this.cancelCallback();
                }
                this.close();
            },
            catCharSelect ($e, n) {
                this.value = $e.value.split(',');
            },
            select (data) {
                this.value = data;
            },
            changRadio (data) {
                this.$emit('changeRadio', data);
            },
            handleCheck (data) {
                this.$emit('handleCheck', data);
            },
            onFileChange ($e) {
                this.$set(this.data, 'name', $e[0].name);
                this.value = $e[0];
                this.errormessage = '';
            }
        },
        components: {
            NormalLabel,
            NormalFileButton,
            ModalHeader,
            NormalButton,
            DropDown,
            MultipleSelect,
            ModalFooter,
            NormalInput,
            NormalRadio,
            CheckBox,
            CheckBoxGroup
        },
        computed: {
            computePlaceholder () {
                return {
                    text: this.placeholderText,
                    textarea: this.placeholderText,
                    drop: this.placeholder || '请选择',
                    multipleSelect: this.placeholder || '请选择',
                };
            },
        },
        mounted () {},
    };
</script>

<template>
    <div class="modal ui2 use-ui2" :class="type">
        <modal-header
            :text="title"
            :is-drag="true"
            :isHideClose="!showCancelOpera"
        ></modal-header>
        <div :class="[contentClass, 'modal-content']">
            <div class="text">
                {{ text }}
            </div>
            <div>
                <template v-if="type === 'text'">
                    <!--:validator="check ? check : null"  :show-error="!!check"-->
                    <normal-input
                        :autofocus="true"
                        :placeholder="computePlaceholder[type]"
                        :maxlength="maxlength"
                        v-model="value"
                    ></normal-input>
                </template>
                <template v-else-if="type === 'drop'">
                    <drop-down
                        :options="data.options"
                        :placeholder="computePlaceholder[type]"
                        @select="select"
                        v-model="data.selected"
                    >
                    </drop-down>
                </template>
                <template v-else-if="type === 'textarea'">
                    <!--:validator="check ? check : null"-->
                    <normal-input
                        :autofocus="true"
                        :resize='resize'
                        type="textarea"
                        :placeholder="computePlaceholder[type]"
                        :show-error="!!check"
                        v-model="value"
                    ></normal-input>
                </template>
                <template v-else-if="type == 'multipleSelect'">
                    <multiple-select
                        :placeholder="computePlaceholder[type]"
                        :options="data.options"
                        float="left"
                        :sampleText="sampleText"
                        :limitShow="limitShow"
                        v-model="data.selected"
                        :withSearch="multiWithSearch"
                        :showCheckedAll="multiSelShowCheckedAll"
                        @select="catCharSelect($event)"
                        :showChoosed="showMultiChoosed"
                    >
                    </multiple-select>
                </template>
                <template v-else-if="type == 'radio'">
                    <template v-for="(item, index) in data.options">
                        <normal-radio
                            @change="changRadio"
                            name="promptRadio"
                            :label="index"
                            :key="index"
                            v-model="data.selected"
                            class="normal-radio"
                        >
                            {{ item }}
                        </normal-radio>
                    </template>
                </template>
                <template v-else-if="type == 'checkbox'">
                    <check-box-group v-model="data.selected">
                        <template v-for="(item, index) in data.options">
                            <check-box
                                @check="handleCheck"
                                :label="index"
                                :key="index"
                                class="normal-radio"
                                :text='item'
                            >
                            </check-box>
                        </template>
                    </check-box-group>
                </template>
                <template v-else-if="type === 'file'">
                    <div class="row">
                        <normal-file-button @change="onFileChange($event);"
                                            icon="&#xe64e;"
                                            marginRight="2"
                                            :text="placeholder || '请选择文件'"
                                            theme="blue"/>
                        <normal-label v-if="data.name">
                            <div class="file-name">{{ data.name }}</div>
                        </normal-label>
                    </div>
                </template>
            </div>
            <div class="row">
                <span
                    class="tips-text error left"
                    v-show="typeof this.errormessage === 'string'"
                >{{ this.errormessage }}</span>
                <span class="tips-text limit right" v-show="limit > 0"
                >已输入：{{ value.length }}个字</span
                >
            </div>
        </div>
        <modal-footer>
            <normal-button
                @click="onPrompt()"
                float="right"
                :disabled="okDisabledCheck ? okDisabledCheck() : false"
                class="modal-footer-btn__center"
                :text="btnText[0] || '确定'"
                theme="blue"
            ></normal-button>
            <normal-button
                @click="onDestroy()"
                class="modal-footer-btn__center"
                :disabled="cancelDisabledCheck ? cancelDisabledCheck() : false"
                float="right"
                v-if="showCancelOpera"
                :margin-right="2"
                :text="btnText[1] || '取消'"
                theme="grey"
            ></normal-button>
        </modal-footer>
    </div>
</template>

<style lang="less" scoped>
    @import "../../assets/less/widgets-var.less";

    .modal {
        .modal-style;
        height: auto;
        width: 520px;
        min-height: 280px;

        .modal-content {
            overflow: hidden;

            .normal-input,
            .normal-textarea {
                width: 100%;
                margin-top: 15px;
            }

            .normal-textarea {
                height: 90px;
                margin-bottom: 7px;
            }

            .drop-frame {
                margin-top: 15px;
            }

            .normal-radio {
                margin-top: 15px;
            }
        }

        .file-name {
            max-width: 280px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis
        }

        .tips-text {
            margin-top: 5px;
            font-size: 12px;
        }

        .limit {
            color: @otherBtnBorderNoteClr;
            text-align: right;
        }

        .error {
            width: 65%;
            color: @dangerBg;
        }
    }
</style>
